export default "__VITE_ASSET__DLHHZxCx__"